import { render, staticRenderFns } from "./digitalDialog.vue?vue&type=template&id=6e9ff856&scoped=true"
import script from "./digitalDialog.vue?vue&type=script&lang=js"
export * from "./digitalDialog.vue?vue&type=script&lang=js"
import style0 from "./digitalDialog.vue?vue&type=style&index=0&id=6e9ff856&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ff856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e9ff856')) {
      api.createRecord('6e9ff856', component.options)
    } else {
      api.reload('6e9ff856', component.options)
    }
    module.hot.accept("./digitalDialog.vue?vue&type=template&id=6e9ff856&scoped=true", function () {
      api.rerender('6e9ff856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/approve/components/digitalDialog.vue"
export default component.exports